import React from 'react';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';
import Modal, { ModalButton } from '../../../ui/Modal';

const MyOrdersCancelTheApplication = ({ onClose, onConfirm }) => (
  <Modal
    isOpen={true}
    onClose={onClose}
    title="Отменить заявку"
    subtitle="Действие нельзя отменить."
    size="sm"
    footer={
      <>
        <ModalButton variant="ghost" onClick={onClose}>Не отменять</ModalButton>
        <ModalButton variant="danger" onClick={onConfirm}>
          <CancelOutlinedIcon sx={{ fontSize: 18 }} />
          Отменить заявку
        </ModalButton>
      </>
    }
  >
    <p style={{ margin: 0, fontSize: 13.5, lineHeight: 1.55, color: '#6F6259' }}>
      Заявка будет переведена в статус «Отменён пользователем».
      Производство и доставка получат уведомление.
    </p>
  </Modal>
);

export default MyOrdersCancelTheApplication;
